/**
 * Riempie le variabili {{NOME}} nell'ANTEPRIMA, e solo li'.
 *
 * Nel template e nell'HTML esportato le variabili restano com'erano: le sostituisce il
 * backend al momento dell'invio, con i dati del destinatario vero (app/Http/helpers.php).
 * In anteprima pero' un footer che recita "© {{ANNO_CORRENTE}} Rossi S.r.l." sembra un
 * difetto, e con i segnaposto non si vede se la riga sta dentro la larghezza o va a capo —
 * che e' la domanda per cui si apre l'anteprima.
 *
 * Due nature diverse, di proposito:
 *  - data e ora si calcolano come le calcola il backend, quindi sono valori VERI;
 *  - i dati dell'azienda destinataria sono un ESEMPIO coerente (stessa azienda immaginaria
 *    in tutti i campi): in anteprima un destinatario non c'e'.
 * Una variabile che non conosciamo resta visibile com'e': quasi sempre e' un nome sbagliato,
 * e nasconderla vorrebbe dire far scoprire l'errore al destinatario.
 */

function due(n) {
	return n < 10 ? '0' + n : String(n)
}

function esempi() {
	var ora = new Date()
	var data = due(ora.getDate()) + '/' + due(ora.getMonth() + 1) + '/' + ora.getFullYear()
	var orario = due(ora.getHours()) + ':' + due(ora.getMinutes())

	return {
		// Valori veri, calcolati come all'invio
		ANNO_CORRENTE: String(ora.getFullYear()),
		DATA_OGGI: data,
		DATA_ORA_OGGI: data + ' ' + orario,
		ORA: orario,

		// Destinatario di esempio: un'unica azienda immaginaria, campi coerenti fra loro
		AZIENDA_NOME: 'Rossi Arredamenti S.r.l.',
		AZIENDA_VIA: 'Via Giuseppe Verdi',
		AZIENDA_NUMERO_CIVICO: '18',
		AZIENDA_COD_POSTALE: '50122',
		AZIENDA_CITTA: 'Firenze',
		AZIENDA_PROVINCIA: 'FI',
		AZIENDA_TELEFONO_PRIMARIO: '055 1234567',
		AZIENDA_TELEFONO_SECONDARIO: '339 1234567',
		AZIENDA_EMAIL_PRIMARIA: 'info@rossiarredamenti.it',
		AZIENDA_EMAIL_SECONDARIA: 'ordini@rossiarredamenti.it',
		AZIENDA_EMAIL_PEC: 'rossiarredamenti@pec.it',
		AZIENDA_PIVA: '01234567890',
		AZIENDA_CODFISCALE: 'RSSMRA80A01D612H',
		AZIENDA_IBAN: 'IT60X0542811101000000123456',
		CONTATTO_NOME: 'Marco Rossi',
		USERNAME: 'Marco Rossi'
	}
}

// Quelle che all'invio valgono uguale per tutti i destinatari: le sole vere anche fuori dall'anteprima
var GENERALI = ['ANNO_CORRENTE', 'DATA_OGGI', 'DATA_ORA_OGGI', 'ORA']

/**
 * Input:  html della mail con le variabili ancora dentro; soloGenerali per il render dato all'assistente
 * Fa:     sostituisce quelle conosciute; lascia intatte le altre. Nel render per l'assistente solo
 *         data e ora: un "{{ANNO_CORRENTE}}" grezzo lo scambia per una variabile inventata, mentre
 *         l'azienda di esempio la leggerebbe come un nome sbagliato, e le variabili del
 *         destinatario lui le conosce gia' per nome
 * Output: html per l'anteprima o per il render — mai per l'esportazione o l'invio
 */
export function fillPreviewVariables(html, soloGenerali) {
	var valori = esempi()
	if (soloGenerali) {
		var tutti = valori
		valori = {}
		GENERALI.forEach(function(nome) { valori[nome] = tutti[nome] })
	}

	return String(html || '').replace(/\{\{\s*([A-Z0-9_]+)\s*\}\}/g, function(intero, nome) {
		return valori[nome] != null ? valori[nome] : intero
	})
}
